// @ts-nocheck
(() => {
  'use strict';

  if (window.__vhpCollectionReelsLoaded) return;
  window.__vhpCollectionReelsLoaded = true;

  const MUTE_KEY = 'vhp-reel-muted';
  const SCROLL_HINT_KEY = 'vhp-reel-scroll-hint-shown';
  const ENTRY_SHIMMER_KEY = 'vhp-reel-entry-shimmer-shown';

  let currentMuted = (() => {
    try {
      const saved = sessionStorage.getItem(MUTE_KEY);
      return saved === null ? true : saved === '1';
    } catch (_) {
      return true;
    }
  })();

  const hasSeenScrollHint = () => {
    try {
      return localStorage.getItem(SCROLL_HINT_KEY) === '1';
    } catch (_) {
      return false;
    }
  };

  const markScrollHintSeen = () => {
    try {
      localStorage.setItem(SCROLL_HINT_KEY, '1');
    } catch (_) {}
  };

  const hasSeenEntryShimmer = () => {
    try {
      return localStorage.getItem(ENTRY_SHIMMER_KEY) === '1';
    } catch (_) {
      return false;
    }
  };

  const markEntryShimmerSeen = () => {
    try {
      localStorage.setItem(ENTRY_SHIMMER_KEY, '1');
    } catch (_) {}
  };

  const playEntryShimmer = (entry) => {
    if (!entry || hasSeenEntryShimmer() || prefersReducedMotion()) return;

    const cleanup = () => {
      entry.classList.remove('is-shimmering');
      entry.removeEventListener('animationend', onEnd);
      entry.removeEventListener('click', onClick);
      markEntryShimmerSeen();
    };
    const onEnd = (e) => {
      if (e.animationName !== 'vhp-reel-entry-shimmer') return;
      cleanup();
    };
    const onClick = () => cleanup();

    window.setTimeout(() => {
      if (hasSeenEntryShimmer()) return;
      entry.classList.add('is-shimmering');
      entry.addEventListener('animationend', onEnd);
      entry.addEventListener('click', onClick, { once: true });
    }, 1200);
  };

  const prefersReducedMotion = () => {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {
      return false;
    }
  };

  const isReelModeParam = () => {
    const v = new URLSearchParams(window.location.search).get('reel_mode');
    return v === 'true' || v === '1';
  };

  const stripReelModeParam = () => {
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('reel_mode')) return;
      url.searchParams.delete('reel_mode');
      const qs = url.searchParams.toString();
      const next = url.pathname + (qs ? `?${qs}` : '') + url.hash;
      window.history.replaceState(window.history.state, '', next);
    } catch (_) {}
  };

  const endReelBoot = () => {
    document.documentElement.classList.remove('vhp-reel-boot');
  };

  const stateByOverlay = new WeakMap();

  const shuffleArray = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const getOrderedReelCards = (grid) => {
    const cards = [
      ...grid.querySelectorAll('.recipe-card.card-media-full:not([data-vhp-reel-skip])'),
    ];
    return shuffleArray(cards);
  };

  const persistMute = (muted) => {
    try {
      sessionStorage.setItem(MUTE_KEY, muted ? '1' : '0');
    } catch (_) {}
  };

  const getActiveSlide = (overlay) => {
    const state = stateByOverlay.get(overlay);
    if (!state) return null;
    return state.track.children[state.activeIndex] || null;
  };

  const getDeferredMedia = (slide) =>
    slide ? slide.querySelector('deferred-media') : null;

  const shouldPreloadAdjacentReels = () => {
    if (prefersReducedMotion()) return false;
    try {
      const conn =
        navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn?.saveData) return false;
      if (conn?.effectiveType && /^(slow-2g|2g)$/.test(conn.effectiveType)) return false;
    } catch (_) {}
    return true;
  };

  const cancelAdjacentPreload = (state) => {
    if (!state?.preloadIdleId) return;
    if (typeof cancelIdleCallback === 'function' && state.preloadIdleKind === 'idle') {
      cancelIdleCallback(state.preloadIdleId);
    } else {
      clearTimeout(state.preloadIdleId);
    }
    state.preloadIdleId = null;
    state.preloadIdleKind = null;
  };

  const preloadAdjacentSlides = (overlay) => {
    if (!shouldPreloadAdjacentReels()) return;
    const state = stateByOverlay.get(overlay);
    if (!state || !overlay.classList.contains('is-open')) return;

    cancelAdjacentPreload(state);

    const run = () => {
      state.preloadIdleId = null;
      state.preloadIdleKind = null;
      if (!overlay.classList.contains('is-open')) return;

      const slides = Array.from(state.track.children);
      const neighbors = [state.activeIndex - 1, state.activeIndex + 1];

      neighbors.forEach((idx) => {
        if (idx < 0 || idx >= slides.length) return;
        const slide = slides[idx];
        if (slide.dataset.hasVideo !== 'true') return;
        const dm = getDeferredMedia(slide);
        if (!dm || dm.getAttribute('data-media-loaded')) return;
        if (typeof dm.preloadContent === 'function') {
          dm.preloadContent();
        }
      });
    };

    if (typeof requestIdleCallback === 'function') {
      state.preloadIdleKind = 'idle';
      state.preloadIdleId = requestIdleCallback(run, { timeout: 1500 });
    } else {
      state.preloadIdleKind = 'timeout';
      state.preloadIdleId = window.setTimeout(run, 200);
    }
  };

  const updateMuteButton = (overlay) => {
    const btn = overlay.querySelector('[data-vhp-reel-mute]');
    if (!btn) return;
    btn.setAttribute('data-state', currentMuted ? 'muted' : 'unmuted');
    btn.setAttribute('aria-label', currentMuted ? 'Ton einschalten' : 'Ton ausschalten');
  };

  const applyMuteToActive = (overlay) => {
    const dm = getDeferredMedia(getActiveSlide(overlay));
    if (dm && typeof dm.setMuted === 'function') dm.setMuted(currentMuted);
  };

  const PAUSE_ICON_SVG =
    '<svg viewBox="0 0 24 24" width="40" height="40" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';

  const PLAY_ICON_SVG =
    '<svg viewBox="0 0 24 24" width="40" height="40" fill="currentColor" aria-hidden="true"><path d="M7 4v16l13-8L7 4z"/></svg>';

  const showStatusIcon = (overlay, isPlaying) => {
    const icon = overlay.querySelector('[data-vhp-reel-status]');
    const iconHolder = overlay.querySelector('[data-vhp-reel-status-svg]');
    if (!icon || !iconHolder) return;
    iconHolder.innerHTML = isPlaying ? PAUSE_ICON_SVG : PLAY_ICON_SVG;
    icon.setAttribute('data-state', isPlaying ? 'playing' : 'paused');
    icon.classList.remove('is-visible');
    void icon.offsetWidth;
    icon.classList.add('is-visible');
    if (icon._vhpHideTimer) clearTimeout(icon._vhpHideTimer);
    if (isPlaying) {
      icon._vhpHideTimer = window.setTimeout(() => {
        icon.classList.remove('is-visible');
      }, 700);
    }
  };

  const hideStatusIcon = (overlay) => {
    const icon = overlay.querySelector('[data-vhp-reel-status]');
    if (!icon) return;
    if (icon._vhpHideTimer) clearTimeout(icon._vhpHideTimer);
    icon.classList.remove('is-visible');
  };

  const setMuteState = (overlay, muted) => {
    currentMuted = !!muted;
    persistMute(currentMuted);
    updateMuteButton(overlay);
    applyMuteToActive(overlay);
  };

  const buildSlide = (sourceCard, tmpl) => {
    const linkEl = sourceCard.querySelector('.recipe-card__link');
    const href = (linkEl && linkEl.getAttribute('href')) || '#';

    const clone = sourceCard.cloneNode(true);

    clone.querySelectorAll('.card-save').forEach((n) => n.remove());

    const cloneLink = clone.querySelector('.recipe-card__link');
    if (cloneLink && cloneLink.parentElement) {
      const parent = cloneLink.parentElement;
      while (cloneLink.firstChild) {
        parent.insertBefore(cloneLink.firstChild, cloneLink);
      }
      cloneLink.remove();
    }

    clone.querySelectorAll('deferred-media').forEach((dm) => {
      dm.removeAttribute('data-media-loaded');
      dm.querySelectorAll(':scope > video, :scope > iframe').forEach((n) => n.remove());
      dm.removeAttribute('data-card-video-autoplay');
      dm.removeAttribute('onclick');
      delete dm.dataset.autoplayStarted;
      delete dm.dataset.autoplayObserved;
      dm.classList.remove('is-loading', 'is-ready');
    });

    const fragment = tmpl.content.cloneNode(true);
    const slide = fragment.querySelector('[data-vhp-reel-slide]');
    const cardHost = slide.querySelector('[data-vhp-reel-card]');
    const cta = slide.querySelector('[data-vhp-reel-cta]');

    cardHost.appendChild(clone);
    if (cta) {
      cta.setAttribute('href', href);
      const ctaLabel = sourceCard.dataset.vhpReelCtaLabel;
      const ctaSubtitle = sourceCard.dataset.vhpReelCtaSubtitle;
      const labelEl = cta.querySelector('.vhp-reel-cta__label');
      const subtitleEl = cta.querySelector('.vhp-reel-cta__subtitle');
      if (ctaLabel && labelEl) labelEl.textContent = ctaLabel;
      if (ctaSubtitle && subtitleEl) {
        subtitleEl.textContent = ctaSubtitle;
        subtitleEl.hidden = false;
      } else if (subtitleEl && !ctaSubtitle) {
        subtitleEl.textContent = '';
        subtitleEl.hidden = true;
      }
    }
    slide.dataset.hasVideo = clone.querySelector('deferred-media') ? 'true' : 'false';

    // GA4 Rezept-Klick tracking
    if (cta) {
      cta.addEventListener('click', () => {
        if (typeof gtag === 'function') {
          gtag('event', 'reel_recipe_click', {
            recipe_url: cta.getAttribute('href'),
          });
        }
      });
    }

    sourceCard.dataset.vhpReelMirrored = '1';
    return slide;
  };

  const computeActiveIndex = (track) => {
    const total = track.children.length;
    if (total === 0) return -1;
    const slideHeight = track.clientHeight;
    if (slideHeight === 0) return 0;
    const idx = Math.round(track.scrollTop / slideHeight);
    return Math.max(0, Math.min(total - 1, idx));
  };

  const activateSlide = (overlay) => {
    const state = stateByOverlay.get(overlay);
    if (!state) return;
    const slides = Array.from(state.track.children);
    if (slides.length === 0) return;

    const active = slides[state.activeIndex];
    const activeHasVideo = active ? active.dataset.hasVideo === 'true' : false;
    overlay.setAttribute('data-has-video', activeHasVideo ? 'true' : 'false');

    hideStatusIcon(overlay);

    slides.forEach((slide, idx) => {
      const dm = getDeferredMedia(slide);
      if (idx === state.activeIndex) {
        slide.setAttribute('data-active', '');
        if (!dm) return;
        if (dm.getAttribute('data-media-loaded')) {
          if (typeof dm.playMedia === 'function') dm.playMedia();
        } else if (typeof dm.showDeferredMedia === 'function') {
          dm.showDeferredMedia();
        }
        requestAnimationFrame(() => {
          if (typeof dm.setMuted === 'function') dm.setMuted(currentMuted);
        });
      } else {
        slide.removeAttribute('data-active');
        if (dm && typeof dm.pauseMedia === 'function') dm.pauseMedia();
      }
    });

    preloadAdjacentSlides(overlay);
    maybeLoadMore(overlay);
  };

  const maybeLoadMore = (overlay) => {
    const state = stateByOverlay.get(overlay);
    if (!state) return;
    const total = state.track.children.length;
    if (total === 0) return;
    if (state.activeIndex < total - 2) return;

    const loadMoreBtn = state.root.querySelector('#loadMoreBtn');
    if (!loadMoreBtn || loadMoreBtn.disabled) return;

    const wrap = state.root.querySelector('#loadMoreWrap');
    if (wrap && wrap.style.display === 'none') return;

    loadMoreBtn.click();
  };

  const togglePlayPause = (overlay) => {
    const dm = getDeferredMedia(getActiveSlide(overlay));
    if (!dm || typeof dm.toggleMedia !== 'function') return;
    dm.toggleMedia();
    const isPlaying = !!dm.isPlaying;
    showStatusIcon(overlay, isPlaying);
  };

  const showShareToast = (message) => {
    const toast = document.createElement('div');
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    Object.assign(toast.style, {
      position: 'fixed',
      left: '50%',
      bottom: 'calc(24px + env(safe-area-inset-bottom))',
      transform: 'translateX(-50%)',
      padding: '10px 16px',
      borderRadius: '999px',
      background: 'rgba(0, 0, 0, 0.82)',
      color: '#fff',
      fontSize: '13px',
      zIndex: '10000',
      pointerEvents: 'none',
    });
    document.body.appendChild(toast);
    window.setTimeout(() => toast.remove(), 1500);
  };

  const shareActiveReel = async (overlay) => {
    const slide = getActiveSlide(overlay);
    if (!slide) return;

    const href = slide.querySelector('[data-vhp-reel-cta]')?.getAttribute('href');
    if (!href || href === '#') return;

    const url = new URL(href, window.location.origin).href;
    const titleEl = slide.querySelector('.card-title');
    const title = titleEl?.textContent?.trim() || document.title;
    const text = title ? `Schau dir „${title}" an.` : 'Schau dir dieses Rezept an.';

    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (_) {}
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        showShareToast('Link kopiert!');
        return;
      }
    } catch (_) {}

    try {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
      showShareToast('Link kopiert!');
    } catch (_) {
      showShareToast('Teilen nicht möglich');
    }
  };

  const showScrollHint = (overlay) => {
    const state = stateByOverlay.get(overlay);
    if (!state) return;
    const track = state.track;
    if (!track || track.children.length < 2) return;
    if (prefersReducedMotion()) return;

    state.hintAnimating = true;

    const prevSnap = track.style.scrollSnapType;
    track.style.scrollSnapType = 'none';

    let cancelled = false;
    const cancel = () => { cancelled = true; };
    const cancelEvents = ['touchstart', 'pointerdown', 'wheel', 'keydown'];
    cancelEvents.forEach((ev) =>
      track.addEventListener(ev, cancel, { once: true, passive: true })
    );

    const peakOffset = 60;
    const downMs = 240;
    const holdMs = 140;
    const upMs = 520;
    const totalMs = downMs + holdMs + upMs;
    const start = performance.now();

    const cleanup = () => {
      cancelEvents.forEach((ev) => track.removeEventListener(ev, cancel));
      state.hintAnimating = false;
      track.style.scrollSnapType = prevSnap;
    };

    const tick = (now) => {
      if (cancelled || !overlay.classList.contains('is-open')) {
        track.scrollTop = 0;
        cleanup();
        return;
      }
      const elapsed = now - start;
      let offset;
      if (elapsed < downMs) {
        const t = elapsed / downMs;
        offset = peakOffset * (1 - Math.pow(1 - t, 3));
      } else if (elapsed < downMs + holdMs) {
        offset = peakOffset;
      } else if (elapsed < totalMs) {
        const t = (elapsed - downMs - holdMs) / upMs;
        offset = peakOffset * Math.pow(1 - t, 3);
      } else {
        offset = 0;
      }

      track.scrollTop = offset;

      if (elapsed < totalMs) {
        requestAnimationFrame(tick);
      } else {
        track.scrollTop = 0;
        cleanup();
      }
    };

    requestAnimationFrame(tick);
  };

  const openOverlay = (root, overlay) => {
    if (overlay.classList.contains('is-open')) return true;

    const grid = root.querySelector('#recipeGrid');
    const track = overlay.querySelector('[data-vhp-reel-track]');
    const tmpl = overlay.querySelector('[data-vhp-reel-template]');
    if (!grid || !track || !tmpl) return false;

    grid.querySelectorAll('[data-vhp-reel-mirrored]').forEach((c) => {
      delete c.dataset.vhpReelMirrored;
    });
    track.innerHTML = '';

    grid.querySelectorAll('deferred-media[data-media-loaded]').forEach((dm) => {
      try {
        if (typeof dm.pauseMedia === 'function') dm.pauseMedia();
      } catch (_) {}
    });

    getOrderedReelCards(grid).forEach((card) => {
      track.appendChild(buildSlide(card, tmpl));
    });

    if (track.children.length === 0) return false;

    const prevScrollY = window.scrollY;
    document.body.style.top = `-${prevScrollY}px`;
    document.body.classList.add('vhp-reel-open');

    overlay.hidden = false;
    overlay.classList.add('is-open');

    const entryBtn = root.querySelector('[data-vhp-reel-entry]');
    if (entryBtn) entryBtn.setAttribute('aria-expanded', 'true');

    const state = {
      root,
      grid,
      track,
      tmpl,
      entryBtn,
      activeIndex: 0,
      prevScrollY,
      rafPending: false,
      gridObserver: null,
      escHandler: null,
      handleScroll: null,
      reelOpenTime: Date.now(),
    };
    stateByOverlay.set(overlay, state);

    state.handleScroll = () => {
      if (state.rafPending || state.hintAnimating) return;
      state.rafPending = true;
      requestAnimationFrame(() => {
        state.rafPending = false;
        const idx = computeActiveIndex(state.track);
        if (idx < 0 || idx === state.activeIndex) return;
        state.activeIndex = idx;
        activateSlide(overlay);
        // GA4 swipe tracking
        const activeSlide = overlay.querySelector('[data-vhp-reel-slide][data-active]');
        const recipeLink = activeSlide ? activeSlide.querySelector('[data-vhp-reel-cta]') : null;
        if (typeof gtag === 'function') {
          gtag('event', 'reel_swipe', {
            recipe_url: recipeLink ? recipeLink.getAttribute('href') : '',
            slide_index: idx
          });
        }
      });
    };
    track.addEventListener('scroll', state.handleScroll, { passive: true });

    state.escHandler = (e) => {
      if (e.key === 'Escape') closeOverlay(overlay);
    };
    document.addEventListener('keydown', state.escHandler);

    state.gridObserver = new MutationObserver(() => {
      let added = false;
      grid.querySelectorAll('.recipe-card.card-media-full:not([data-vhp-reel-skip])').forEach((card) => {
        if (card.dataset.vhpReelMirrored === '1') return;
        track.appendChild(buildSlide(card, tmpl));
        added = true;
      });
      if (added) maybeLoadMore(overlay);
    });
    state.gridObserver.observe(grid, { childList: true });

    track.scrollTop = 0;
    state.activeIndex = 0;
    updateMuteButton(overlay);
    requestAnimationFrame(() => activateSlide(overlay));

    if (!hasSeenScrollHint() && !prefersReducedMotion()) {
      state.scrollHintTimer = window.setTimeout(() => {
        if (!overlay.classList.contains('is-open')) return;
        showScrollHint(overlay);
        markScrollHintSeen();
      }, 2000);
    }

    // GA4 reel open tracking
    if (typeof gtag === 'function') {
      gtag('event', 'reel_open', {
        collection: root.dataset.collectionHandle || 'unknown'
      });
    }

    return true;
  };

  const closeOverlay = (overlay) => {
    const state = stateByOverlay.get(overlay);
    if (!state) return;

    // GA4 reel close tracking
    if (typeof gtag === 'function') {
      gtag('event', 'reel_close', {
        duration_seconds: Math.round((Date.now() - state.reelOpenTime) / 1000),
        slides_viewed: state.activeIndex + 1
      });
    }

    if (state.scrollHintTimer) {
      clearTimeout(state.scrollHintTimer);
      state.scrollHintTimer = null;
    }
    cancelAdjacentPreload(state);
    state.hintAnimating = false;
    state.track.style.scrollSnapType = '';

    overlay.querySelectorAll('deferred-media').forEach((dm) => {
      try {
        if (typeof dm.pauseMedia === 'function') dm.pauseMedia();
      } catch (_) {}
    });

    if (state.gridObserver) state.gridObserver.disconnect();
    if (state.escHandler) document.removeEventListener('keydown', state.escHandler);
    if (state.handleScroll) state.track.removeEventListener('scroll', state.handleScroll);

    state.grid.querySelectorAll('[data-vhp-reel-mirrored]').forEach((c) => {
      delete c.dataset.vhpReelMirrored;
    });
    state.track.innerHTML = '';

    overlay.classList.remove('is-open');
    overlay.removeAttribute('data-has-video');
    overlay.hidden = true;

    if (state.entryBtn) {
      state.entryBtn.setAttribute('aria-expanded', 'false');
    }

    document.body.classList.remove('vhp-reel-open');
    document.body.style.top = '';
    window.scrollTo(0, state.prevScrollY);

    if (state.entryBtn) {
      try { state.entryBtn.focus({ preventScroll: true }); } catch (_) {}
    }

    stateByOverlay.delete(overlay);
    stripReelModeParam();
  };

  const tryAutoOpenReel = (root) => {
    if (!isReelModeParam()) return;

    const overlay = root.querySelector('[data-vhp-reel-overlay]');
    if (!overlay) {
      endReelBoot();
      stripReelModeParam();
      return;
    }

    const run = () => {
      try {
        openOverlay(root, overlay);
        stripReelModeParam();
      } finally {
        endReelBoot();
      }
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(run);
    });
  };

  const bindOverlayChrome = (overlay) => {
    if (overlay.dataset.vhpReelChromeBound === '1') return;
    overlay.dataset.vhpReelChromeBound = '1';

    const closeBtn = overlay.querySelector('[data-vhp-reel-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => closeOverlay(overlay));

    const muteBtn = overlay.querySelector('[data-vhp-reel-mute]');
    if (muteBtn) {
      muteBtn.addEventListener('click', () => setMuteState(overlay, !currentMuted));
    }

    const shareBtn = overlay.querySelector('[data-vhp-reel-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        shareActiveReel(overlay);
      });
    }

    overlay.addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const slide = target.closest('[data-vhp-reel-slide]');
      if (!slide) return;
      if (target.closest('[data-vhp-reel-control], [data-vhp-reel-cta]')) return;
      if (overlay.getAttribute('data-has-video') === 'false') return;
      togglePlayPause(overlay);
    });
  };

  const init = (root) => {
    if (!root) return;
    const overlay = root.querySelector('[data-vhp-reel-overlay]');
    if (!overlay) return;

    bindOverlayChrome(overlay);

    const entry = root.querySelector('[data-vhp-reel-entry]');
    if (entry && entry.dataset.vhpReelEntryBound !== '1') {
      entry.dataset.vhpReelEntryBound = '1';
      entry.addEventListener('click', () => openOverlay(root, overlay));
      if (!isReelModeParam()) {
        playEntryShimmer(entry);
      }
    }

    tryAutoOpenReel(root);
  };

  window.initVhpCollectionReels = init;

  const autoInit = () => {
    document.querySelectorAll('.vhp-collection-section').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit, { once: true });
  } else {
    autoInit();
  }
})();